module.exports = __webpack_public_path__ + "img/1.8c935a13.png";